import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import decorationTop from "../../assets/decoration (1).png";
import decorationBottom from "../../assets/decoration.png";
import {
  autoCancelFlutterwaveTransactions,
  verifyFlutterwaveTransaction,
} from "../../Redux/promotionsSlice";
import Loader from "../Loader/Loader";

const DeepLinkWithFlutterwavePaymentStatus = () => {
  const dispatch = useDispatch();


  const params = useMemo(() => new URLSearchParams(window.location.search), []);


  const status = params.get("status");
  const transaction_id = params.get("transaction_id");
  const tx_ref = params.get("tx_ref");

  const hasPaymentParams = Boolean(status);


  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);


  useEffect(() => {
    if (!hasPaymentParams) return;

    const verifyPayment = async () => {
      if (status === "successful" && transaction_id) {
        setIsLoading(true);
        try {
          const response = await dispatch(
            verifyFlutterwaveTransaction({
              id: transaction_id,
              autoHandle: true,
            })
          ).unwrap();

          setIsSuccess(Boolean(response?.data?.isSuccess));
        } catch (error) {
          setIsSuccess(false);
        } finally {
          setIsLoading(false);
        }
      } else {
        try {
          await dispatch(
            autoCancelFlutterwaveTransactions({
              paymentReference: tx_ref,
            })
          ).unwrap();
        } catch (error) {
          console.error(error);
        }
        setIsSuccess(false);
      }
    };

    verifyPayment();
  }, [status, transaction_id, dispatch, hasPaymentParams, tx_ref]);


  return (
    <div className="relative w-full min-h-screen bg-[#d7becf] flex items-center justify-center overflow-hidden">
      <Loader loading={isLoading} />

      <img
        src={decorationBottom}
        alt="Bottom Decoration"
        className="absolute bottom-0 left-0 max-w-[300px] w-full pointer-events-none"
      />
      <img
        src={decorationTop}
        alt="Top Decoration"
        className="absolute top-0 right-0 max-w-[500px] w-full pointer-events-none"
      />

      <div className="w-full lg:max-w-[600px] max-w-[800px] bg-white p-6 sm:p-8 rounded-md z-10">
        <div className="flex flex-col gap-6">
          {/* Logo */}
          <div className="flex justify-center">
            <img src="/newLogo.png" alt="logo" className="w-44" />
          </div>

          {/* {hasPaymentParams && (
            <div className="text-center">
              <p className="text-[18px] font-semibold mb-2">
                {isSuccess ? "Payment Successful 🎉" : "Payment Failed ❌"}
              </p>
              <p className="text-gray-700 mb-6">
                {isSuccess
                  ? "Your payment has been processed successfully."
                  : "Your payment was not completed."}
              </p>
            </div>
          )} */}

          {hasPaymentParams && (
            <div className="text-center">
              <p className="text-[18px] font-semibold mb-2">
                {isSuccess ? "Payment Successful 🎉" : "Payment Failed ❌"}
              </p>

              <p className="text-gray-700 mb-6">
                {isSuccess
                  ? "Your payment has been processed successfully."
                  : "Your payment was not completed."}
              </p>

              <div className="text-left bg-gray-50 p-4 rounded-md border space-y-3">
                <div className="flex items-center justify-between text-sm gap-4">
                  <span className="font-medium min-w-[140px]">Status:</span>
                  <span className="flex-1 text-right break-all capitalize">{status || "N/A"}</span>
                </div>

                <div className="flex items-center justify-between text-sm gap-4">
                  <span className="font-medium min-w-[140px]">Transaction ID:</span>
                  <span className="flex-1 text-right break-all">
                    {transaction_id || "N/A"}
                  </span>
                </div>

                <div className="flex items-center justify-between text-sm gap-4">
                  <span className="font-medium min-w-[140px]">Transaction Ref:</span>
                  <span className="flex-1 text-right break-all">{tx_ref || "N/A"}</span>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
};

export default DeepLinkWithFlutterwavePaymentStatus;
